import React from 'react'
import DrakeComp from '../../components/sponsorships/drake/Drake'

const Drake = () => {
  return (
    <DrakeComp/>
  )
}

export default Drake